import { put, select, takeLatest } from 'redux-saga/effects'
import { getProcedureStateSelector } from '../../../../components/procedure/selectors'
import { setInputRows } from '../../../../components/procedure/store/procedure.actions'
import { IProcedureState } from '../../../../components/procedure/store/procedure.types'
import { getWoundCareSelector } from '../selectors'
import { WoundCareConstants } from '../store/woundCare.constants'
import { IWoundCareState } from '../store/woundCare.types'

export function* setSite() {
  const procedureState: IProcedureState = yield select(getProcedureStateSelector)
  const woundCareState: IWoundCareState = yield select(getWoundCareSelector)
  const { inputRows } = procedureState
  const { site } = woundCareState
  inputRows.map((row) =>
    row.inputs.map((input) => {
      if (input.key === WoundCareConstants.SET_SITE) {
        //@ts-ignore
        input.props.savedValues = site
      }
    })
  )
  yield put(setInputRows(inputRows))
}

export function* setSiteSaga() {
  yield takeLatest([WoundCareConstants.SET_SITE], setSite)
}
